import { json, postBiz, rows } from '../core/coreapi';
import {
  ActivityProgrammeFilters,
  ActivityProgrammeRow,
  AxisSummary,
  ProgrammeCards,
  StatusSummary,
  TransitionResult,
} from './activityprogramme.models';
import {
  normalizeAxisSummary,
  normalizeProgrammeCards,
  normalizeProgrammeRows,
  normalizeStatusSummary,
  normalizeTransition,
} from './activityprogramme.normalizers';

export const fetchProgrammeCards = async (
  filters: ActivityProgrammeFilters,
): Promise<ProgrammeCards> =>
  normalizeProgrammeCards(
    json(await postBiz({ s: 'activityprogramme', a: 'cards', ...filters })),
  );

export const fetchProgrammeReview = async (
  filters: ActivityProgrammeFilters,
  offset = 0,
  limit = 500,
): Promise<ActivityProgrammeRow[]> =>
  normalizeProgrammeRows(
    rows(
      await postBiz({
        s: 'activityprogramme',
        a: 'review',
        ...filters,
        pgo: offset,
        pgl: limit,
      }),
    ),
  );

export const fetchAxisSummary = async (
  filters: ActivityProgrammeFilters,
): Promise<AxisSummary[]> =>
  rows(await postBiz({ s: 'activityprogramme', a: 'axis', ...filters })).map(
    normalizeAxisSummary,
  );

export const fetchStatusSummary = async (
  filters: ActivityProgrammeFilters,
): Promise<StatusSummary[]> =>
  rows(await postBiz({ s: 'activityprogramme', a: 'status', ...filters })).map(
    normalizeStatusSummary,
  );

export const notifyProgrammeRows = async (
  ids: number[],
  type: 'GENERAL' | 'INCOMPLETE',
  message?: string,
) =>
  json(
    await postBiz({
      s: 'activityprogramme',
      a: 'notify',
      ids,
      ntp: type,
      msg: message || null,
    }),
  );

export const notifyFilteredProgrammeRows = async (
  filters: ActivityProgrammeFilters,
  incompleteOnly: boolean,
  type: 'GENERAL' | 'INCOMPLETE',
  message?: string,
) =>
  json(
    await postBiz({
      s: 'activityprogramme',
      a: 'notifyfiltered',
      ...filters,
      inc: incompleteOnly,
      ntp: type,
      msg: message || null,
    }),
  );

export const transitionProgrammeRow = async (
  row: ActivityProgrammeRow,
  action: 'COMPLETE' | 'CERTIFY' | 'RETURN',
  reason?: string,
): Promise<TransitionResult> =>
  normalizeTransition(
    json(
      await postBiz({
        s: 'activityprogramme',
        a: 'transition',
        rid: row.activityplanid,
        act: action,
        rsn: reason || null,
        stp: row.stamp || null,
      }),
    ),
  );

export const bulkTransitionProgrammeRows = async (
  ids: number[],
  action: 'COMPLETE' | 'CERTIFY' | 'RETURN',
  reason?: string,
): Promise<TransitionResult> =>
  normalizeTransition(
    json(
      await postBiz({
        s: 'activityprogramme',
        a: 'bulktransition',
        ids,
        act: action,
        rsn: reason || null,
      }),
    ),
  );
